// Mock data for Care Ambulance Service

export const brandInfo = {
  name: "Care Ambulance Service",
  tagline: "Advanced Life Support Ambulance – Critical Care When Every Second Counts",
  subtext: "24/7 Emergency Support With Highly Trained Paramedics",
  phones: ["8921311300", "9847267071"],
  email: "careambulance24@gmail.com",
  address: "Care Ambulance Service, Opposite Karothukuzhi Hospital, Aluva 683101",
  mapLink: "https://share.google/WE2kUNjfkk8S89SWw",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.0!2d76.3571!3d10.1081!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTDCsDA2JzI5LjIiTiA3NsKwMjEnMjUuNiJF!5e0!3m2!1sen!2sin!4v1234567890",
  whatsappNumber: "918921311300"
};

export const services = [
  {
    id: 1,
    title: "Advanced Life Support (ALS)",
    description: "We provide fully equipped ALS services with the following portable medical equipment and trained personnel:",
    icon: "ActivitySquare",
    features: [
      "Neonatal Portable Ventilator",
      "Adult Portable Ventilator",
      "Portable Cardiac Monitor",
      "Portable Suction Machine",
      "Portable Syringe Pump",
      "Portable Oxygen Supply",
      "Portable Incubator",
      "Portable BiPAP Machine",
      "Intubation Kit",
      "Spine Board",
      "AED (Automated External Defibrillator)",
      "BPL Defibrillator",
      "Wheelchair Access",
      "Essential Medicines",
      "Trained Staff Nurse",
      "On-Call Doctor Facility"
    ]
  },
  {
    id: 2,
    title: "Basic Life Support (BLS)",
    description: "Our BLS services include:",
    icon: "Heart",
    features: [
      "Immediate EMS Call Assistance",
      "Spine Board Availability",
      "Oxygen Supply Facility"
    ]
  },
  {
    id: 3,
    title: "Human Remains Transportation Services",
    description: "We offer respectful and professional transportation of human remains:",
    icon: "HeartPulse",
    features: [
      "Nationwide transportation by road and air",
      "Embalming services",
      "Washing and disinfection of the body",
      "Coffin box facility",
      "International transportation available"
    ]
  },
  {
    id: 4,
    title: "Air Ambulance (24/7)",
    description: "Rapid and professional emergency air transfer for critical patients, VIPs, or loved ones.",
    icon: "Ambulance",
    features: []
  },
  {
    id: 5,
    title: "Funeral Support Services",
    description: "Additional funeral support services:",
    icon: "Siren",
    features: [
      "Coffin Box Hire: Available for funeral services or body transportation through funeral homes or ambulance services",
      "Hearse Services: Specially designed vehicles with secure coffin compartments and air conditioning for preservation",
      "Body Freezer Box Rental: High-quality refrigerated units (mortuary boxes) to preserve deceased individuals and prevent decomposition"
    ]
  }
];

export const aboutText = "Care Ambulance Service provides 24/7 emergency and critical care ambulance services across Aluva. Our ALS ambulances come with advanced medical equipment including ventilators, cardiac monitors, IV medications, and defibrillators. With trained paramedics and rapid response capability, we ensure safe and professional emergency care when every second matters.";

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1670140399896-1038e88c183d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhbWJ1bGFuY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjMzMTcxNjR8MA&ixlib=rb-4.1.0&q=85",
    title: "Ambulance Interior",
    category: "interior"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1568821362855-dfe81f116d14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxhbWJ1bGFuY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjMzMTcxNjR8MA&ixlib=rb-4.1.0&q=85",
    title: "Medical Equipment View",
    category: "interior"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/28123680/pexels-photo-28123680.jpeg",
    title: "Emergency Response",
    category: "response"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/8942630/pexels-photo-8942630.jpeg",
    title: "Emergency Scene",
    category: "response"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1516549655169-df83a0774514?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc2MzMxNzE2OXww&ixlib=rb-4.1.0&q=85",
    title: "Medical Facility",
    category: "equipment"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1595464144526-5fb181b74625?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc2MzMxNzE2OXww&ixlib=rb-4.1.0&q=85",
    title: "Monitoring Equipment",
    category: "equipment"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1551076805-e1869033e561?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxtZWRpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc2MzMxNzE2OXww&ixlib=rb-4.1.0&q=85",
    title: "Hospital Bed",
    category: "equipment"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/3845129/pexels-photo-3845129.jpeg",
    title: "Medical Equipment",
    category: "equipment"
  }
];

export const heroImage = "https://images.unsplash.com/photo-1554734867-bf3c00a49371";